
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.5 21C4.701 21 0 16.299 0 10.5S4.701 0 10.5 0 21 4.701 21 10.5 16.299 21 10.5 21zm1.26-14.51H8.82v-.8h2.94v.8zm2.518-.124h-1.905v-.939c0-.213-.188-.387-.42-.387H8.206c-.232 0-.421.174-.421.387v.939H5.881c-.233 0-.421.173-.421.387 0 .213.188.387.42.387h8.398c.233 0 .422-.174.422-.387 0-.214-.189-.387-.422-.387zm-.85 1.614a.427.427 0 00-.43.423v6.4c0 .172-.143.31-.318.31H7.48a.314.314 0 01-.317-.31v-6.4a.427.427 0 00-.432-.423.428.428 0 00-.432.423v6.4c0 .638.53 1.157 1.181 1.157h5.198a1.17 1.17 0 001.181-1.157v-6.4a.427.427 0 00-.431-.423zm-3.836 5.476V8.384c0-.223-.252-.404-.562-.404-.31 0-.562.181-.562.404v5.072c0 .223.252.404.562.404.31 0 .562-.181.562-.404zm2.1 0V8.384c0-.223-.251-.404-.563-.404-.31 0-.562.181-.562.404v5.072c0 .223.252.404.562.404.312 0 .564-.181.564-.404z","fill":"#000","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/trash.svg